import { FaMapMarkerAlt, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AddressStatCard = ({
  totalAddresses = 0,
  maxAddresses = 5,
  primaryLabel = "Home",
  setOpen
}) => {
  const navigate = useNavigate();
  const canAddMore = totalAddresses < maxAddresses;

  return (
    <div
      className="stat-card address-card"
      //onClick={() => navigate("/my-addresses")}
    >
      <FaMapMarkerAlt className="stat-icon address" />

      <div className="stat-content">
        <h3>
          {totalAddresses} / {maxAddresses}
        </h3>

        {totalAddresses === 0 && (
          <span className="stat-sub highlight">
            Add your first address
          </span>
        )}

        {totalAddresses > 0 && canAddMore && (
          <span className="stat-sub">
            Primary Address: {primaryLabel}
          </span>
        )}

        {!canAddMore && (
          <span className="stat-sub limit">
            Primary Address: {primaryLabel}
          </span>
        )}
      </div>

      {canAddMore && (<>
        <button
          className="add-address-btn"
          onClick={(e) => {
            e.stopPropagation(); // prevent card click
            setOpen(true);
            //navigate("/my-addresses?add=true");
          }}
          aria-label="Add Address"
        >
          <FaPlus />
        </button>
        </>
      )}
    </div>
  );
};

export default AddressStatCard;
